
















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Branch } from '@/api/model/branch'
import { DashboardView, ReferralAge, ReferralFilterDirection, ReferralStatus, ReferralView, Role } from '@/api/types'
import { ReferralCountAPI } from '@/api/backend-client'
import { ReferralCount } from '@/api/model/referral-count'
import { EventBus } from './EventBus'
const referrals = namespace('referrals')

@Component
export default class SubNavigationLeadTabs extends Vue {
    @referrals.Action applyStatusFilter: ({ statusFilter }) => Promise<void>
    @referrals.Action applyAssignedToBranchFilter: ({ assignedToBranchFilter: [] }) => Promise<void>
    @referrals.Action applyReferredByBranchFilter: ({ referredByBranchFilter: [] }) => Promise<void>
    @referrals.Action applyAssignedToFilter: ({ assignedToFilter: [] }) => Promise<void>
    @referrals.Action applyReferredByFilter: ({ referredByFilter: [] }) => Promise<void>
    @referrals.Action applyDateRangeFilter: ({ range: string }) => Promise<void>
    @referrals.Action applyView: ({ view: string, direction, update: boolean }) => Promise<void>
    @referrals.Action resetFilters: () => Promise<void>
    @referrals.Action applyScoreFilter: ({ scoreFilter }) => Promise<void>
    @referrals.Action applyFilters: (ReferralsStateFilters) => Promise<void>
    @referrals.Action snapshot: () => Promise<void>

    ownerSwitch = true
    filterSwitch = true
    selectedTeam: string | null = null
    count: ReferralCount = null

    async mounted() {
        this.setOwnerDefault()
        await this.updateCount()
    }

    @Watch('ownerSwitch')
    @Watch('filterSwitch')
    @Watch('selectedTeam')
    async updateCount() {
        const result = await ReferralCountAPI.getReferralCount(this.ownerSwitch, this.filterSwitch, this.selectedTeam)
        this.count = result
    }

    setOwner(value: boolean): void {
        this.ownerSwitch = value

        if (this.ownerSwitch) {
            this.selectedTeam = null
        }
    }

    setFilter(value: boolean): void {
        this.filterSwitch = value
    }

    get selectedView(): ReferralView {
        return this.ownerSwitch ? 'user' : 'branches'
    }

    get selectedDirection(): ReferralFilterDirection {
        return this.filterSwitch ? 'in' : 'out'
    }

    async navigateScore(scoreFilter: number): Promise<void> {
        await this.reroute({
            view: this.selectedView,
            direction: this.selectedDirection,
            scoreFilter: [scoreFilter],
            statusFilter: null,
        })
    }

    async navigateAge(ageFilter: ReferralAge): Promise<void> {
        await this.reroute({
            view: this.selectedView,
            direction: this.selectedDirection,
            ageFilter,
            statusFilter: null,
        })
    }

    async navigateStatus(status: string): Promise<void> {
        await this.reroute({
            view: this.selectedView,
            direction: this.selectedDirection,
            statusFilter: status,
        })
    }

    async reroute(filters: any): Promise<void> {
        if (this.selectedTeam) {
            switch (this.selectedDirection) {
                case 'in':
                    filters.assignedToBranchFilter = [this.selectedTeamObject]
                    break
                case 'out':
                    filters.referredByBranchFilter = [this.selectedTeamObject]
                    break
            }
        }

        await this.applyFilters(filters)
        await this.snapshot()

        if (this.$route.name !== 'tasks_all') {
            await this.$router.push({name: 'tasks_all'})
        }

        EventBus.$emit('close')
    }

    get teams(): Branch[] {
        return this.$currentUser.getAvailableBranches()
    }

    get selectedTeamObject(): Branch {
        return this.teams.find(value => value.id === this.selectedTeam)
    }

    get createdFilterLabel(): string {
        return this.ownerSwitch ? this.$t('navigation.leads_menu.my_created').toString() : this.$t('navigation.leads_menu.team_created').toString()
    }

    get assignedFilterLabel(): string {
        return this.ownerSwitch ? this.$t('navigation.leads_menu.my_referred').toString() : this.$t('navigation.leads_menu.team_referred').toString()
    }

    get notEmployeeRole(): boolean {
        return this.$currentUser.role !== Role.EMPLOYEE
    }

    colorForStatus(status: string): object {
        const colors = {
            all: `rgb(110,110,110)`,
            [ReferralStatus.NEW]: `rgba(19, 210, 197, 1)`,
            [ReferralStatus.UNREACHABLE]: `rgba(235, 89, 140, 1)`,
            [ReferralStatus.PENDING]: `rgba(247, 131, 35, 1)`,
            [ReferralStatus.APPOINTMENT]: `rgba(66, 153, 225, 1)`,
            [ReferralStatus.PROPOSAL]: `rgba(145, 105, 226, 1)`,
            [ReferralStatus.ON_HOLD]: `rgba(231, 220, 30, 1)`,
            [ReferralStatus.SUCCESSFUL]: `rgba(0, 163, 137, 1)`,
            [ReferralStatus.PROCESSED]: `rgb(96, 96, 96)`,
            [ReferralStatus.CLOSED]: `rgba(222, 64, 119, 1)`,
        }

        return {color: colors[status]}
    }

    setOwnerDefault() {
        if (this.$currentUser.role !== Role.EMPLOYEE) {
            this.ownerSwitch = this.$currentUser.defaultDashboardView === DashboardView.USER
        }
    }
}

